<section class="order-view-container">
  <db-ecommerce-item-view [pageData]="view"
                          [tableHeads]="heads"
                          [headerGreedStyle]="headerGreedStyle"
                          [headerGreedStyleRefund]="headerGreedStyleRefund"
                          [loading]="loading"
                          [showStats]="false"
                          [website]="website"
                          [orderId]="orderId"
                          [fullRefunded]="+refundsTotalSum === +order?.total"
                          [orderHasRefunds]="!!order?.refunds?.length"
                          [orderHasTestPayment]="!!order?.hasTestEnvironment"
                          (showRefundSection)="handleRefundSectionToggle($event)">
    <db-order-info address [order]="order"  [pageData]="view"></db-order-info>
    <ng-container>
      <ng-container *ngIf="order?.line_items && order?.line_items.length; else emptyTable">
        <section class="order-row"
                 *ngFor="let item of order?.line_items; let i = index"
                 [ngStyle]="headerGreedStyle">
          <div class="order-image-container row-item">
            <img *ngIf="item?.image && item?.image.src" [src]="item?.image?.src"/>
          </div>
          <div class="order-title row-item">
            <a class="db-link long-text" [routerLink]="'../../../products/edit-product/'+item?.product_id">
              {{item?.parent_name || item?.name}}
            </a>
          </div>
          <div class="order-price row-item">
            {{ item.quantity }}
            <db-refund-price *ngIf="Math.abs(item?.refund_details?.quantity) > 0"
                    [price]="item?.refund_details?.quantity">
            </db-refund-price>
          </div>
          <div class="order-price row-item">
            ${{ (item.price * item.quantity) | DbNumberFormatPipe: 'halfUp' : 2 }}
            <db-refund-price
                    *ngIf="Math.abs(item?.refund_details?.total) > 0"
                    [price]="'-$' + Math.abs(item?.refund_details?.total | DbNumberFormatPipe: 'halfUp' : 2)">
            </db-refund-price>
          </div>
          <div class="order-inventory row-item">
            ${{ +item.total_tax | DbNumberFormatPipe: 'halfUp' : 2 }}
            <db-refund-price
                    *ngIf="Math.abs(item?.refund_details?.total_tax) > 0"
                    [price]="'-$' + Math.abs(item?.refund_details?.total_tax | DbNumberFormatPipe: 'halfUp' : 2)">
            </db-refund-price>
          </div>
        </section>
      </ng-container>
      <ng-template #emptyTable>
        <div class="empty-table">
          <span>{{ 'text_customerNoOrder'|dbText }}</span>
        </div>
      </ng-template>
    </ng-container>
    <div class="order-refund">
      <db-refund-info [refund]="refund"  *ngFor="let refund of refunds"></db-refund-info>
    </div>
  </db-ecommerce-item-view>
</section>
